<template>
  <div>
    <transition name="fade">
      <div
        v-if="delayedActive && overlay"
        :class="[
          positionType,
          'z-60 left-0 top-0 h-full w-full bg-white/60 dark:bg-black/60',
        ]"
      ></div>
    </transition>
    <LoadingLogo
      :active="delayedActive"
      :size="size"
      :position="position"
      :position-type="positionType"
    ></LoadingLogo>
    <slot v-if="!delayedActive"></slot>
  </div>
</template>

<script>
import LoadingLogo from '@/components/ui/LoadingLogo';

export default {
  name: 'LoadingOverlay',
  components: {
    LoadingLogo,
  },
  props: {
    active: {
      type: [Boolean, Number],
      default: true,
    },
    delay: {
      type: Number,
      default: 150,
    },
    overlay: {
      type: [Boolean, Number],
      default: true,
    },
    size: {
      type: String,
      default: 'lg',
      validator: (value) => ['sm', 'md', 'lg'].includes(value),
    },
    position: {
      type: String,
      default: 'center',
      validator: (value) =>
        [
          'center',
          'top-right',
          'bottom-right',
          'top-left',
          'bottom-left',
        ].includes(value),
    },
    positionType: {
      type: String,
      default: 'absolute',
      validator: (value) => ['absolute', 'fixed'].includes(value),
    },
  },
  data() {
    return {
      delayedActive: false,
      timer: null,
    };
  },
  watch: {
    active(newVal) {
      if (newVal) {
        this.setDelayed();
      } else {
        this.unsetDelayed();
      }
    },
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  },
  mounted() {
    this.setDelayed();
  },
  methods: {
    setDelayed() {
      if (this.delay) {
        this.timer = setTimeout(() => {
          this.delayedActive = this.active;
        }, this.delay);
      } else {
        this.delayedActive = this.active;
      }
    },
    unsetDelayed() {
      clearTimeout(this.timer);
      this.delayedActive = false;
    },
  },
};
</script>

<style scoped></style>
